import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from 'src/helpers/apiCall'
import { GET } from 'src/consts/methods'
import { RootReducer } from 'src/redux/rootReducer'
import { FETCH_ESTIMATES, FETCH_ESTIMATES_FAIL, FETCH_ESTIMATES_SUCCESS } from 'src/redux/estimatesReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchEstimatesFlow(): Generator<any, void, any> {
  try {
    const currentPage = yield select((state: RootReducer) => state.estimatesReducer.currentPage)
    const sort = yield select((state: RootReducer) => state.estimatesReducer.sort)
    const search = yield select((state: RootReducer) => state.estimatesReducer.search)
    const response = yield call(apiCall, {
      endpoint: '/admin/estimates',
      method: GET,
      params: { page: currentPage, sort, search }
    })
    yield put(FETCH_ESTIMATES_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_ESTIMATES_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchEstimatesSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_ESTIMATES, FetchEstimatesFlow)
}
